module.exports = __webpack_public_path__ + "img/3.054f29d3.png";